import { DOMINIOS_CARDAPIO } from './url-identificador'

const STORAGE_KEY = 'cardapio-sischef:tenant'
const STORAGE_KEY_DISPOSITIVO = 'cardapio-sischef:tenant-totem'
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const CODIGO_ACESSO_RE = /^[a-z0-9][a-z0-9-]{1,98}[a-z0-9]$/i

let emMemoria: string | null = null

export function detectarTenant(): string {
  const segmentos = window.location.pathname.split('/').filter(Boolean)
  if (segmentos[0] === 'checkout' && segmentos[1] && (UUID_RE.test(segmentos[1]) || CODIGO_ACESSO_RE.test(segmentos[1]))) {
    return segmentos[1].toLowerCase()
  }

  const dispositivo = obterTenantDispositivo()
  if (dispositivo) return dispositivo

  const conhecido = tenantConhecido()
  if (conhecido) return conhecido

  return window.location.host.toLowerCase()
}

export function fixarTenantDispositivo(codigo: string | null): void {
  try {
    if (codigo) localStorage.setItem(STORAGE_KEY_DISPOSITIVO, codigo.toLowerCase())
    else localStorage.removeItem(STORAGE_KEY_DISPOSITIVO)
  } catch {
    /* localStorage indisponível — segue em memória */
  }
}

export function obterTenantDispositivo(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY_DISPOSITIVO)
  } catch {
    return null
  }
}

function tenantConhecido(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? emMemoria
  } catch {
    return emMemoria
  }
}

export function obterTenantArmazenado(): string {
  return tenantConhecido() ?? detectarTenant()
}

export function armazenarTenant(t: string): void {
  emMemoria = t
  try {
    sessionStorage.setItem(STORAGE_KEY, t)
  } catch {
    /* sessionStorage indisponível — segue em memória */
  }
}

export function inicializarTenant(): string {
  const t = detectarTenant()
  armazenarTenant(t)
  return t
}

export function tenantDoHost(): string {
  return window.location.host.toLowerCase()
}

export function tenantVeioDoDispositivo(): boolean {
  const dispositivo = obterTenantDispositivo()

  if (!dispositivo) return false

  if (detectarTenant() !== dispositivo) return false

  return dispositivo.toLowerCase() !== tenantDoHost()
}

// IP não serve: o backend quebra o host nos pontos e tentaria `192`
export function hostPodeSerTenant(host: string = tenantDoHost()): boolean {
  const semPorta = host.split(':')[0] ?? ''

  // IPv6 entre colchetes cai no teste do ponto: `[::1]:5173`.split(':')[0] === '['
  if (!semPorta.includes('.')) return false

  return !/^\d{1,3}(\.\d{1,3}){3}$/.test(semPorta)
}

// Não apaga o código do aparelho: se o host também não resolver, o vínculo continua lá
export function tentarTenantDoHost(): boolean {
  if (!hostPodeSerTenant()) return false

  armazenarTenant(tenantDoHost())
  return true
}

// Host da própria plataforma (sischef.shop, localhost) sem loja: é a página principal, não endereço inválido
export function ehPaginaPrincipal(): boolean {
  if (detectarTenant() !== tenantDoHost()) return false

  const semPorta = (tenantDoHost().split(':')[0] ?? '').replace(/^www\./, '')
  return semPorta === 'localhost' || semPorta === '127.0.0.1' || DOMINIOS_CARDAPIO.includes(semPorta)
}
